export class NonError extends Error {
  name = "NonError"

  constructor(input: unknown) {
    super("non-error value captured", { cause: input })
  }
}

// Ensures a value is a valid error by making it one if not
export default function ensureError(input: unknown): Error {
  if (input instanceof Error) {
    return input
  }

  // If it's an error-like object, create a new Error and copy error properties
  // Note: Some error properties are not enumerable and may not be copied automatically with Object.assign, ...obj, etc.
  if (input !== null && typeof input === "object" && !Array.isArray(input)) {
    const errorLike = input as Record<string, unknown>

    const hasErrorProperties = "message" in errorLike || "name" in errorLike || "stack" in errorLike

    if (hasErrorProperties) {
      const message = typeof errorLike.message === "string" ? errorLike.message : "<No error message>"
      const error = new Error(message)
      Object.assign(error, errorLike) // Copy enumerable properties from the error-like object
      error.cause = errorLike.cause
      error.name = typeof errorLike.name === "string" ? errorLike.name : "Error"
      error.stack = typeof errorLike.stack === "string" ? errorLike.stack : "<No stack trace>"
      return error
    }
  }

  return new NonError(input)
}
